import React, { Component } from 'react';
import './styles.css';
import PropTypes from 'prop-types';
import { MultiYearScalarType } from '../../types';
import ThreeYearsTableLayout from '../ThreeYearsTableLayout';
import StarsSpinner from '../StarsSpinner';
import BusinessPlanSubSectionTitle from '../BusinessPlanSubSectionTitle';
import range from 'lodash/range';
import LabelDescription from '../LabelDescription';
import LabelDescriptionIcon from '../LabelDescriptionIcon';
import CheckButton from '../CheckButton';
import SetVariableMutation from '../../mutations/SetVariable';

class ProductionQualityCheck extends Component {
	render() {
		const { Header, Row, Col, Label } = ThreeYearsTableLayout;
		const { game } = this.props;
		const { viewMode } = game;
		const {
			qualityCheckPersonel,
			recyclingAndWasteManagement,
			qualityMaintenance,
			juiceTaster,
			chemicalExpert
		} = game.production;

		const variables = [
			{
				id: 'recycling-and-waste-management',
				value: recyclingAndWasteManagement,
				icon: 'recycle'
			},
			{ id: 'quality-maintenance', value: qualityMaintenance, icon: 'wrench' },
			{ id: 'juice-taster', value: juiceTaster, icon: 'taste' },
			{ id: 'chemical-expert', value: chemicalExpert, icon: 'chemical' }
		];
		return (
			<div className="production-quality-check">
				<BusinessPlanSubSectionTitle label={'production-quality-check-title'} />
				<ThreeYearsTableLayout>
					<Header />
					<Row>
						<Label>
							<LabelDescription label="quality-check-personel" />
						</Label>
						{range(1, 4).map(n => (
							<Col key={n}>
								<SetVariableMutation>
									{setVariable => (
										<StarsSpinner
											starsCount={4}
											n={n}
											min={n === 1 ? 0 : qualityCheckPersonel[n - 2].value}
											active={!viewMode}
											variable={qualityCheckPersonel[n - 1]}
											onChange={(n, value) => {
												if (n === 1) {
													const { name, year } = qualityCheckPersonel[1];
													if (qualityCheckPersonel[1].value < value) {
														setVariable({
															variables: {
																gameID: game.id,
																submission: game.lastSubmission,
																name,
																year,
																value
															}
														}).then(() => {
															if (qualityCheckPersonel[2].value < value) {
																const { name, year } = qualityCheckPersonel[2];
																setVariable({
																	variables: {
																		gameID: game.id,
																		submission: game.lastSubmission,
																		name,
																		year,
																		value
																	}
																});
															}
														});
													}
												}
												if (n === 2) {
													if (qualityCheckPersonel[2].value < value) {
														const { name, year } = qualityCheckPersonel[2];
														setVariable({
															variables: {
																gameID: game.id,
																submission: game.lastSubmission,
																name,
																year,
																value
															}
														});
													}
												}
											}}
										/>
									)}
								</SetVariableMutation>
							</Col>
						))}
					</Row>
					{variables.map(variable => (
						<Row key={variable.id}>
							<Label>
								<LabelDescriptionIcon
									icon={variable.icon}
									label={variable.id}
								/>
							</Label>
							{range(1, 4).map(n => (
								<Col key={n}>
									<CheckButton
										active={!viewMode}
										variable={variable.value[n - 1]}
									/>
								</Col>
							))}
						</Row>
					))}
				</ThreeYearsTableLayout>
			</div>
		);
	}
}

ProductionQualityCheck.propTypes = {
	game: PropTypes.shape({
		id: PropTypes.string.isRequired,
		viewMode: PropTypes.bool,
		production: PropTypes.shape({
			qualityCheckPersonel: MultiYearScalarType,
			recyclingAndWasteManagement: MultiYearScalarType,
			qualityMaintenance: MultiYearScalarType,
			juiceTaster: MultiYearScalarType,
			chemicalExpert: MultiYearScalarType
		})
	})
};

export default ProductionQualityCheck;
